<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Form Layouts" pageTitle="Form Layouts" />
            <FormLayouts />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import FormLayouts from '../FormLayouts/FormLayouts'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'FormLayoutsPage',
    components: {
        MainHeader,
        PageTitle,
        FormLayouts,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>